import { Component, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';

@Component({
    templateUrl: 'campaign.html',
    standalone: false
})

export class EmployerCampaignMockPage implements OnInit {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  loaded: boolean;
  rows: any;
  headers: any;

  
  boundNewCampaign = this.newCampaign.bind(this);

constructor(
    private navCtrl: CustomNavController
  ) {}

  ngOnInit() {
    this.loaded = false;
    this.rows = this.buildRows();
    this.headers = this.buildHeaders();
    this.loaded = true;
  }

  buildHeaders() {
    return [
      'Campaign Name',
      'Frequency',
      'Amount/Employee',
      'Employees',
      'Amount',
      'Groups'
    ];
  }

  buildRows() {
    return [
      {
        'Campaign Name': {
          value: 'Monthly Janitorial',
          action: null
        },
        'Frequency': {
          value: 'Monthly',
          action: null
        },
        'Amount/Employee': {
          value: '$70',
          action: null
        },
        'Employees': {
          value: '900',
          action: null
        },
        'Amount': {
          value: '$63,000',
          action: null
        },
        'Groups': {
          value: 'Full-Time Only',
          action: null
        }
      },
      {
        'Campaign Name': {
          value: 'One-Time Boost Campaign',
          action: null
        },
        'Frequency': {
          value: 'One Time',
          action: null
        },
        'Amount/Employee': {
          value: '$100',
          action: null
        },
        'Employees': {
          value: '1,200',
          action: null
        },
        'Amount': {
          value: '$120,000',
          action: null
        },
        'Groups': {
          value: 'All Employees',
          action: null
        }
      }
    ];
  }

  newCampaign() {
    // TODO: Implement new campaign functionality

  }

}
